//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Time Interval Units */
export const TimeIntervalUnit = {
    /** The seconds */
    Seconds: 0,

    /** The minutes */
    Minutes: 1,

    /** The hours */
    Hours: 2,

    /** The days */
    Days: 3,

    /** The months */
    Months: 4,

    /** The years */
    Years: 5
} as const;

/** Time Interval Units */
export const TimeIntervalUnitDescription: Record<number, string> = {
    0: "Seconds",

    1: "Minutes",

    2: "Hours",

    3: "Days",

    4: "Months",

    5: "Years"
};

/** Time Interval Units */
export type TimeIntervalUnit = typeof TimeIntervalUnit[keyof typeof TimeIntervalUnit];
